import React, { useCallback, useEffect, useState } from "react";
import SelectComponent from "../../../../Components/UiComponents/SelectComponent/SelectComponent";
import DatePicker from "../../Common/Form/DatePicker/DatePicker";
import { useTranslation } from "react-i18next";
import "./DailyGlofReportStatusForm.css";
import Table from "../../../../Components/UiComponents/Table/Table";
import { getExportedColumnsData } from "../../../../Components/UiComponents/utils";
import { setTableData } from "../../../../CentralStore/ExportLMSTable/dataSlice";
import { useDispatch } from "react-redux";
import { postDataWithBody } from "../../../../Services/Services";
import { getglofReportingStatus, getColdwaveReportingStatus, getFireWaveReportingStatus, getForm1StatusData, getHeatWaveReportingStatus } from "../../../../Services/EndPoints";
import moment from "moment";
import ExportTableDataAvalanche from "../../../../Components/UiComponents/Table/TableComponents/ExportTableData/ExportTableDataAvalanche";
const DailyGlofReportStatusForm = ({ setSelectedDate, selectedDate }) => {
  const { t, i18n } = useTranslation();
  const [searchData, setSearchData] = useState();
  const [completeCount, setCompleteCount] = useState(0);
  const dispatch = useDispatch();
  const [reportStatusData, setReportStatusData] = useState([]);

  const columnsForExport = [
    { label: "Name", key: "dist_name" },
    { label: "Total Blocks", key: "total_block_count" },
    { label: "Report Submitted", key: "report_submitted" },
    { label: "Report Not Submitted", key: "report_not_submitted" },
    // { label: "NotAffected Blocks", key: "not_affected" },
    // { label: "TotalMarked Blocks", key: "totalMarkedBlocks" },
  ];

  useEffect(() => {
    sendDataToCentralStore(searchData);
  }, [searchData]);

  const columns = React.useMemo(
    () => [
      {
        Header: "District",
        accessor: "dist_name",
        disableSortBy: true,
      },
      {
        Header: "Total Blocks",
        accessor: "total_block_count",
        disableSortBy: true,
        centerAlign: true,
      },
      {
        Header: "Report Submitted",
        accessor: "report_submitted",
        disableSortBy: true,
        centerAlign: true,
      },
      {
        Header: "Report Not Submitted",
        accessor: "report_not_submitted",
        disableSortBy: true,
        centerAlign: true,
      },
      // {
      //   Header: "NotAffected Blocks",
      //   accessor: "not_affected",
      //   disableSortBy: true,
      //   centerAlign: true,
      // },
      // {
      //   Header: "Total Marked Blocks",
      //   accessor: "totalMarkedBlocks",
      //   disableSortBy: true,
      //   centerAlign: true,
      // },
    ],
    []
  );

  const sendDataToCentralStore = (data) => {
    if (data?.length > 0) {
      const columns = columnsForExport;
      console.log(data);
      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, data),
        })
      );
    }
  };
  const getForm1StatusHandler = async () => {
    try {
      let data = await postDataWithBody(
        getglofReportingStatus,
        { reportedOn: selectedDate },
        {}
      );
  
      setReportStatusData(data);
      sendDataToCentralStore(data);
  
      const completedCount = data.filter(
        (item) => item.total_block_count === item.report_submitted
      ).length;
      
      setCompleteCount(completedCount);
    } catch (error) {
      console.error("Error fetching form status data:", error);
    }
  };

  return (
    <div className="report__status">
      <div className="flood__report--container">
        <div className="px-2 d-flex">
          <div>
            <label className="mb-2">Date</label>
            <div className="date_picker_flood_container me-1">
              <DatePicker
                selected={selectedDate}
                defaultDateValue={moment().format("YYYY-MM-DD")}
                maxDate={new Date().toISOString().split("T")[0]}
                name="flood_date_picker"
                setDate={setSelectedDate}
                className="form-control date-picker date_picker_flood"
              />
            </div>
          </div>

          <button
            className="btn btn-success ms-2 mt-1 btn-sm flood__statusreport--button"
            onClick={() => getForm1StatusHandler()}
          >
            {t("floodreport.buttonapply")}
          </button>
          <div className="me-2 region_type_container d-flex align-items-center">
            <div className="completed_count">
              Completed Count : {completeCount}
            </div>
          </div>
          <ExportTableDataAvalanche
            data={getExportedColumnsData(columnsForExport, reportStatusData)}
            columns={columnsForExport}
            filename={`DailyGlofReportStatus_${selectedDate}`}
            setIsExportDisabled={() => {}}
            showAsButton={true}
            label="Download"
            buttonClassName="btn btn-success ms-2 mt-1 btn-sm flood__statusreport--button download-status-btn"
          />
        </div>
      </div>

      <div className="p-2">
        <div className="datatable__container">
          {reportStatusData && (
            <Table
              data={reportStatusData}
              columns={columns}
              numberOfRows={7}
              showExport={false}
              showFilter={false}
              showReset={false}
              onExpand={false}
              // showRowCount={false}
              rowCount={reportStatusData?.length || 0}
              setSearchData={setSearchData}
              headerTableHeadStyle={{ background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)", color: "#FFFFFF" }}
              tableStyle={{
                border: "1px solid  #f0f0f0",
                padding: "0px 2px 2px 0px",
                borderRadius: "12px",
              }}
              applyTableHeaderCustomClass={true}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DailyGlofReportStatusForm;
